import { usePagination, UsePaginationProps } from "react-instantsearch-core-v7";

// This component is used to create a virtual algolia pagination
// that is not rendered in the DOM.
// This is necessary so we can prefilter the refinements before they
// are used.
function VirtualPagination(props: UsePaginationProps): null {
  usePagination(props);

  return null;
}

export { VirtualPagination };
